import useApiService from "./useApiService";

const useBank = () => {
  const { put, post, get } = useApiService();
  const updateBankDetails = async (bankId, data) => {
    try {
      const response = await put(`/api/banks/${bankId}`, data);
      if (response.status) return { success: "Bank details updated successfully.", data: response.data };
      else throw new Error("Error updating bank details");
    } catch (error) {
      return { error };
    }
  };

  const addBankAccount = async (parentName, parentId, data) => {
    try {
      const response = await post(`/api/banks/${parentName}/${parentId}`, data);
      if (response.status) return { success: "Bank account added successfully.", data: response.data };
      else throw new Error("Error adding bank account");
    } catch (error) {
      return { error };
    }
  };

  const getAurusBankDetails = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const userId = user.id;
      const response = await get(`/api/banks/aurus_group/${userId}`);
      if (response.status && response.data) {
        const banks = response.data.map((bank) => ({
          ...bank,
          bank_identification: bank.bank_identification?.id,
          bank_identification_url: bank.bank_identification?.url,
          bank_branch: bank.bank_branch_name,
        }));
        return { banks: banks };
      } else {
        throw new Error("Unable to fetch bank details");
      }
    } catch (error) {
      return { error };
    }
  };

  return { updateBankDetails, addBankAccount, getAurusBankDetails };
};

export default useBank;
